import React, { useRef } from 'react';
import { customers } from '../data/mock';
import useScrollAnimation from '../hooks/useScrollAnimation';

// Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';

// سبک‌های Swiper
import 'swiper/css';

const CustomerSlider = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const swiperRef = useRef(null);

  if (!customers || customers.length === 0) {
    return null;
  }

  return (
    <section
      id="customers"
      ref={ref}
      className={`scroll-mt-32 py-16 bg-gray-50 fade-in-up ${isVisible ? 'visible' : ''}`}
      dir="rtl"
    >
      <div className="pp-container">
        {/* تیتر */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            مشتریان و همکاران
          </h2>
          <p className="text-gray-600">اعتماد بزرگ‌ترین شرکت‌های کشور</p>
        </div>

        {/* اسلایدر مشتریان */}
        <div
          className="customer-slider-wrapper"
          onMouseEnter={() => {
            if (swiperRef.current) swiperRef.current.autoplay.stop();
          }}
          onMouseLeave={() => {
            if (swiperRef.current) swiperRef.current.autoplay.start();
          }}
        >
          <Swiper
            modules={[Autoplay, FreeMode]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            loop={true}
            freeMode={true}
            grabCursor={true}
            speed={5000}              // حرکت نرم و پیوسته
            autoplay={{
              delay: 0,               // بدون مکث بین اسلایدها
              disableOnInteraction: false,
            }}
            slidesPerView={2}
            spaceBetween={24}
            breakpoints={{
              640: { slidesPerView: 3, spaceBetween: 32 },
              1024: { slidesPerView: 5, spaceBetween: 40 },
            }}
            className="!overflow-hidden"
          >
            {customers.map((customer) => (
              <SwiperSlide key={customer.id}>
                <div
                  className="
                    w-full h-20 sm:h-24
                    bg-white rounded-lg border border-gray-200
                    flex items-center justify-center
                    hover:shadow-lg transition-shadow
                  "
                >
                  <img
                    src={customer.logo}
                    alt={customer.name}
                    className="
                      max-w-[110px] sm:max-w-[120px]
                      max-h-[50px] sm:max-h-[60px]
                      object-contain
                      grayscale hover:grayscale-0
                      transition-all
                    "
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default CustomerSlider;
